'use client';

import { Elements } from '@prezly/content-renderer-react-js';
import type { BookmarkNode } from '@prezly/story-content-format';
import { useMemo } from 'react';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import { optimizeOembedThumbnail } from './lib';

interface Props {
    node: BookmarkNode;
}

export function WebBookmark({ node }: Props) {
    const isMobile = useBreakpoint('xs', 'below');

    const nodeWithResizedThumbnail = useMemo(
        () => ({
            ...node,
            oembed: optimizeOembedThumbnail(node.oembed, node.layout, isMobile),
        }),
        [node, isMobile],
    );

    return <Elements.Bookmark node={nodeWithResizedThumbnail} />;
}
